import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycabrentalsinindia() {



  const cardData =
  {
    keyword: 'Luxury Cab Rentals in India',
    heading: 'Aaryan Travels: Luxury Cab Rentals in India',
    headingDescription: ' Aaryan Travels offers premium Luxury Cab Rentals in India for business executives, VIP guests, weddings, and high-end travel requirements across major cities like Delhi, Mumbai, Pune, Bangalore, Hyderabad, and Chennai. Whether you need a luxury sedan, premium SUV, or chauffeur-driven limousine for airport transfers, corporate events, celebrity travel, or special occasions, our fleet guarantees elegance and comfort. With professional chauffeurs, well-maintained vehicles, bottled water, and on-request amenities like Wi-Fi and refreshments, we ensure a distinguished travel experience. From hotel pickups to long-distance journeys, Aaryan Travels is the trusted choice for luxury car rentals with drivers across India.',

    top: 'Top Places to Visit in India with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Taj Mahal, Agra",
    "description": "The Taj Mahal, one of the Seven Wonders of the World, was built by Emperor Shah Jahan in memory of his wife Mumtaz Mahal. Made from white marble with intricate carvings, it changes color with the daylight. The reflecting pool and symmetrical gardens enhance its beauty. Millions visit annually to witness its timeless charm. The Taj Mahal is India’s eternal monument of love."
  },
  {
    "title": "Golden Temple, Amritsar",
    "description": "The Golden Temple, also known as Harmandir Sahib, is the holiest shrine of Sikhism. Its gold-plated structure reflects beautifully in the surrounding Amrit Sarovar. Devotees and visitors from across the world experience peace through Gurbani hymns. The temple’s Langar serves free meals to thousands daily. The Golden Temple is India’s shining emblem of unity and devotion."
  },
  {
    "title": "Jaipur City Palace, Rajasthan",
    "description": "City Palace in Jaipur is a royal complex combining Rajput and Mughal architecture. Visitors admire its grand courtyards, museums, and the intricately designed Peacock Gate. Part of the palace still houses the royal family. Traditional textiles, weaponry, and paintings showcase regal heritage. City Palace is India’s proud symbol of royal legacy."
  },
  {
    "title": "Varanasi Ghats, Uttar Pradesh",
    "description": "Varanasi, one of the world’s oldest cities, is lined with sacred ghats along the Ganga River. Pilgrims perform rituals, meditation, and holy dips at sunrise. The evening Ganga Aarti with lamps and chants creates a divine experience. Narrow lanes filled with temples add to its charm. Varanasi is India’s living spiritual capital."
  },
  {
    "title": "Kerala Backwaters, Alleppey",
    "description": "The Kerala Backwaters offer serene houseboat cruises through interconnected lagoons and canals. Surrounded by coconut groves and paddy fields, it provides a peaceful escape into nature. Traditional meals are served onboard while floating gently. Sunset views over still waters are breathtaking. The backwaters are India’s floating paradise."
  },
  {
    "title": "Rann of Kutch, Gujarat",
    "description": "The Great Rann of Kutch is a vast salt desert that glows silver under moonlight. The annual Rann Utsav features folk music, dance, and luxury tent stays. Camel rides and handicraft shopping make it a cultural delight. The sunrise and sunset views are magical. The Rann is India’s surreal white wonderland."
  },
  {
    "title": "Mysore Palace, Karnataka",
    "description": "Mysore Palace is an opulent royal residence with stained glass windows, domes, and ornate halls. Every Sunday and during Dasara, it is illuminated with nearly 100,000 bulbs. The interiors showcase royal thrones, artwork, and grand architecture. It is one of the most visited palaces in India. Mysore Palace is India’s glowing marvel of royalty."
  },
  {
    "title": "Gateway of India, Mumbai",
    "description": "The Gateway of India is a monumental arch built facing the Arabian Sea. It marked the ceremonial entrance during British rule. Tourists gather for sea breeze, street snacks, and ferry rides to Elephanta Caves. Its impressive structure reflects Indo-Saracenic architecture. The Gateway of India is Mumbai’s coastal landmark of grandeur."
  },
  {
    "title": "Ajanta & Ellora Caves, Maharashtra",
    "description": "Ajanta and Ellora Caves are ancient rock-cut monuments featuring Buddhist, Hindu, and Jain sculptures. Ajanta is known for its stunning fresco paintings, while Ellora’s Kailasa Temple is carved from a single rock. These UNESCO World Heritage Sites showcase extraordinary craftsmanship. The caves are India’s historic gallery of art and devotion."
  },
  {
    "title": "Andaman & Nicobar Islands",
    "description": "The Andaman Islands offer crystal-clear waters, coral reefs, and pristine beaches like Radhanagar. Activities like snorkeling and scuba diving reveal vibrant marine life. The historic Cellular Jail tells stories of India’s freedom struggle. Dense forests and boat rides add adventure. Andaman is India’s tropical escape to tranquility."
  }
],


"services": [
  {
    "name": "Luxury Cab Rentals in India",
    "description": "Luxury Cab Rentals in India provide an exclusive fleet of high-end vehicles designed for travelers who prioritize comfort, style, and sophistication. Our rental options include luxury sedans, SUVs, and premium cars equipped with modern amenities such as leather interiors, Wi-Fi, and climate control. Whether for weddings, corporate events, or leisure trips, our luxury rentals guarantee a memorable and hassle-free experience, supported by professional chauffeurs committed to exceptional service."
  },
  {
    "name": "India Luxury Car Hire",
    "description": "India Luxury Car Hire offers a seamless way to access premium vehicles across major cities and tourist destinations. We cater to discerning customers seeking reliable, chauffeur-driven rides that combine elegance and performance. Our luxury car hire services are perfect for business executives, VIP guests, and travelers desiring a first-class journey with personalized attention, punctuality, and utmost safety."
  },
  {
    "name": "Premium Taxi India",
    "description": "Premium Taxi India specializes in providing top-tier taxi services with a focus on luxury and exclusivity. Our fleet includes high-end sedans and SUVs driven by trained chauffeurs who understand the importance of discretion, professionalism, and client comfort. Ideal for airport transfers, corporate travel, and special occasions, our premium taxis deliver a sophisticated travel experience."
  },
  {
    "name": "Chauffeur Driven Luxury India",
    "description": "Chauffeur Driven Luxury India offers a distinguished service where professional drivers ensure a smooth and elegant ride in luxury vehicles. Our chauffeurs are extensively trained in etiquette and local knowledge, guaranteeing punctuality and a discreet environment for business meetings, client visits, or leisurely trips. We pride ourselves on delivering an unparalleled combination of comfort, safety, and style."
  },
  {
    "name": "Luxury Sedan Rentals India",
    "description": "Luxury Sedan Rentals India feature a curated selection of high-performance sedans, including brands like Mercedes-Benz, BMW, and Audi. These vehicles are ideal for business travel, weddings, and upscale city tours. Our service includes flexible rental durations, with options for hourly, daily, or long-term hires, complemented by professional chauffeur services ensuring a premium travel experience."
  },
  {
    "name": "Luxury SUV Rentals India",
    "description": "Luxury SUV Rentals India cater to those who desire spaciousness without compromising on style or performance. Our fleet includes top models from Lexus, Range Rover, and Cadillac, offering comfort for family outings, corporate events, and airport transfers. Each rental comes with a well-trained driver, safety features, and personalized service tailored to meet the highest expectations."
  },
  {
    "name": "Corporate Luxury Cab India",
    "description": "Corporate Luxury Cab India delivers executive transportation solutions tailored to meet the needs of high-profile business clients. We provide premium vehicles with chauffeur services for meetings, client pickups, airport transfers, and corporate events. Our service emphasizes discretion, reliability, and luxury to reflect the prestige of your company and clients."
  },
  {
    "name": "Best Luxury Cab India",
    "description": "Best Luxury Cab India stands out for combining a premium fleet with exceptional customer service across the country. We offer top-rated luxury cars and professional chauffeurs dedicated to providing an unmatched travel experience. Whether you require a one-time ride or ongoing transport solutions, our services are tailored to exceed your expectations in comfort and class."
  },
  {
    "name": "Luxury Cab Packages India",
    "description": "Luxury Cab Packages India offer comprehensive travel solutions bundled for events, tours, and corporate needs. These packages include customized itineraries, chauffeur-driven luxury vehicles, and additional amenities like refreshments and Wi-Fi. Ideal for weddings, city tours, and executive travel, our packages provide convenience, flexibility, and premium service at competitive rates."
  },
  {
    "name": "Wedding Luxury Cab India",
    "description": "Wedding Luxury Cab India specializes in providing elegant and stylish transportation for weddings and related events. Our fleet includes luxury sedans and SUVs adorned with decorations, ensuring a grand entrance and comfortable rides for the bridal party and guests. Chauffeurs are trained to deliver courteous service, punctuality, and assistance with luggage and arrangements, making your special day flawless."
  },
  {
    "name": "Airport Luxury Taxi India",
    "description": "Airport Luxury Taxi India offers timely and comfortable airport transfers in premium vehicles to and from major airports across India. Our chauffeurs monitor flight schedules to ensure punctual pickups and drop-offs, assisting with luggage and providing a stress-free start or end to your journey. Enjoy the convenience and exclusivity of a luxury taxi dedicated to your travel needs."
  },
  {
    "name": "High End Cab India",
    "description": "High End Cab India features an elite fleet of vehicles equipped with cutting-edge technology, plush interiors, and superior ride quality. Our services cater to clients who demand the best in terms of comfort, safety, and style. Whether for business, leisure, or special occasions, our high-end cabs ensure an exceptional travel experience that reflects your status and taste."
  },
  {
    "name": "Luxury Vehicle Hire India",
    "description": "Luxury Vehicle Hire India provides access to an extensive range of premium cars for hire, including convertibles, limousines, and exotic sports cars. Perfect for those who want to make a statement or enjoy a unique driving experience, our service includes professional chauffeurs and flexible rental terms. We ensure every journey is comfortable, safe, and unforgettable."
  },
  {
    "name": "Elite Cab Rentals India",
    "description": "Elite Cab Rentals India offers bespoke transportation solutions featuring luxury cars and SUVs driven by highly trained chauffeurs. Our service is tailored for clients who seek exclusivity, reliability, and the utmost in comfort. From airport transfers to corporate events and personal outings, we provide a seamless and premium cab rental experience nationwide."
  },
  {
    "name": "Luxury Chauffeur Services India",
    "description": "Luxury Chauffeur Services India emphasize professionalism, discretion, and exceptional hospitality. Our chauffeurs are trained not only to drive but to anticipate client needs, ensuring a smooth and luxurious travel experience. Available across major cities, this service is ideal for executives, VIPs, and anyone looking for premium chauffeur-driven transportation."
  }
],
"tableData": [
  ["Luxury Cab Rentals in India", "India Luxury Car Hire"],
  ["Premium Taxi India", "Chauffeur Driven Luxury India"],
  ["Luxury Sedan Rentals India", "Luxury SUV Rentals India"],
  ["Corporate Luxury Cab India", "Best Luxury Cab India"],
  ["Luxury Cab Packages India", "Wedding Luxury Cab India"],
  ["Airport Luxury Taxi India", "High End Cab India"],
  ["Luxury Vehicle Hire India", "Elite Cab Rentals India"],
  ["Luxury Chauffeur Services India", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Premium Luxury Cab Rentals Across India",
    "WhyChoosedescription": "Aaryan Travels offers top-notch luxury cab rentals nationwide for an elegant and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Fleet of High-End Vehicles",
    "WhyChoosedescription": "Choose from premium sedans, SUVs, and luxury cars maintained to the highest standards for your comfort and style."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs Providing Discreet Service",
    "WhyChoosedescription": "Our experienced and courteous drivers ensure safe, punctual, and private rides across all destinations."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in sanitized, immaculate vehicles equipped with modern amenities for a premium experience."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy upfront pricing including fuel, tolls, and driver allowances without any surprises."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with your luxury cab rental bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for Business and Leisure",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance luxury travel tailored to your needs."
  },
  {
    "WhyChooseheading": "Commitment to Safety and Customer Satisfaction",
    "WhyChoosedescription": "We prioritize your safety and satisfaction, ensuring a smooth and elegant travel experience every time."
  }
]
































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury cab rentals across India?',
    answer: 'Yes, Aaryan Travels provides premium luxury cab rental services throughout India, featuring top-brand vehicles for a comfortable and stylish ride.',
  },
  {
    question: 'How can I book luxury cab rentals in India with Aaryan Travels?',
    answer: 'You can easily book luxury cabs through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of luxury vehicles are available for rental across India?',
    answer: 'We offer a wide range of luxury cars including Mercedes, BMW, Audi, and other high-end vehicles to suit your travel needs.',
  },
  {
    question: 'Are chauffeurs trained and professional for luxury cab rentals?',
    answer: 'Absolutely. Our chauffeurs are professionally trained, courteous, and committed to providing a premium travel experience.',
  },
  {
    question: 'Is luxury cab rental service available for both local and outstation trips in India?',
    answer: 'Yes, Aaryan Travels offers luxury cab rentals for both local rides and outstation journeys across India.',
  },
  {
    question: 'Can I book luxury cabs for special occasions across India?',
    answer: 'Yes, our luxury cab rental services are perfect for weddings, corporate events, airport transfers, and other special occasions.',
  },
  {
    question: 'Is luxury cab rental service available 24x7 across India?',
    answer: 'Yes, we provide round-the-clock luxury cab rental services to accommodate your schedule anywhere in India.',
  },
  {
    question: 'What safety and hygiene protocols are followed for luxury cab rentals in India?',
    answer: 'All vehicles are regularly sanitized, and chauffeurs follow strict safety and hygiene guidelines to ensure passenger safety.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for luxury cab rentals across India?',
    answer: 'Yes, you can specify your preferred pickup and drop-off locations anywhere in India as per your travel plans.',
  },
  {
    question: 'What payment options are accepted for luxury cab rentals in India?',
    answer: 'We accept cash, cards, UPI, and popular digital wallets for secure and convenient payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Khan',
    feedback: 'Aaryan Travels provided an outstanding luxury cab rental experience across India. The cars were top-notch and the service impeccable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Sharma',
    feedback: 'Highly recommend Aaryan Travels for luxury cab rentals in India. Professional chauffeurs and excellent vehicles.',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];






const luxuryCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Cab Rentals in India",
  "description": "Aaryan Travels offers premium luxury cab rentals across India including chauffeur-driven luxury cars, luxury sedans, SUVs, corporate luxury cabs, wedding luxury taxis, and airport luxury transfers.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "serviceType": "Luxury Cab Rentals",
  "keywords": "Luxury Cab Rentals in India, India Luxury Car Hire, Premium Taxi India, Chauffeur Driven Luxury India, Luxury Sedan Rentals India, Luxury SUV Rentals India, Corporate Luxury Cab India, Best Luxury Cab India, Luxury Cab Packages India, Wedding Luxury Cab India, Airport Luxury Taxi India, High End Cab India, Luxury Vehicle Hire India, Elite Cab Rentals India, Luxury Chauffeur Services India"
};







  return (
    <div>

<Helmet>
  <title>Luxury Cab Rentals in India | Premium Chauffeur Services | Aaryan Travels</title>
  <meta
    name="description"
    content="Experience premium luxury cab rentals across India with Aaryan Travels. Chauffeur-driven sedans and SUVs for corporate travel, weddings, airport transfers, and special occasions."
  />
  <meta
    name="keywords"
    content="Luxury Cab Rentals in India, India Luxury Car Hire, Premium Taxi India, Chauffeur Driven Luxury India, Luxury Sedan Rentals India, Luxury SUV Rentals India, Corporate Luxury Cab India, Best Luxury Cab India, Luxury Cab Packages India, Wedding Luxury Cab India, Airport Luxury Taxi India, High End Cab India, Luxury Vehicle Hire India, Elite Cab Rentals India, Luxury Chauffeur Services India"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryCabSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycabrentalsinindia;